module.exports = __webpack_public_path__ + "static/media/epinard.815852b9.jpg";